<template>
  <Public bg="tw-bg-light-gray">
    <v-main>
      <div class="tw-container tw-mx-auto tw-text-center tw-p-5">
        <div class="tw-pt-10 tw-prose-sm md:tw-prose tw-max-w-none">
          <h1>เลือกแพ็คเกจที่เหมาะกับธุรกิจของคุณ</h1>
          <p>เชื่อมต่อโปรแกรมบัญชีมากกว่า 9 โปรแกรมบัญชีชั้นนำทั้งไทยและต่างประเทศ
            พร้อมด้วยการพัฒนาอย่างต่อเนื่องเพิื่อเพิ่มฟังก์ชั่นการใช้งาน</p>
        </div>
        <package-option :on-select-package="onSelectPackage"></package-option>
      </div>
      <div class="tw-bg-white tw-py-20">
        <div class="tw-container tw-mx-auto tw-text-center">
          <div class="tw-prose tw-max-w-none">
            <h1 class="tw-mb-1">อยากได้แพ็คเกจที่ใช่ในแบบของคุณ</h1>
            <p>สร้างแพ็คเกจที่เหมาะกับคุณได้ง่าย</p>
            <button class="tw-bg-light-green tw-text-white tw-py-2 tw-px-20 tw-rounded-md">พูดคุยกับทีมงานของเรา
            </button>
          </div>
        </div>
      </div>
      <footer-web></footer-web>
    </v-main>
  </Public>
</template>

<script>
import Public from '@/components/public/public-main-template'
import FooterWeb from '@/components/public/footer'
import PackageOption from '@/components/company/package'
import router from "@/router";


export default {
  name: 'Package',
  components: {
    Public,
    FooterWeb,
    PackageOption
  },
  methods: {
    onSelectPackage: function () {
      router.push('/company-add')
    }
  },
}
</script>
